import React from "react";

/**
 * Badge Component
 * 
 * A small status indicator or label.
 * 
 * @component
 * @param {Object} props
 * @param {string} props.variant - Visual style variant (default, primary, secondary, success, ColorGreen)
 * @param {string} props.size - Size variant (sm, md, lg)
 * 
 * @example
 * <Badge variant="primary" size="sm">New</Badge>
 */
export const Badge = ({
  children,
  variant = "default",
  size = "md",
  className = "",
  ...props
}) => {
  const variants = {
    default: "bg-grey-500 text-red-400",
    primary: "bg-red-300 text-grey-500",
    secondary: "bg-gray-500 text-grey-500",
    success: "bg-green-500 text-red-500",
    ColorGreen: "bg-green-500 text-grey-500",
  };

  const sizes = {
    sm: "px-2.5 py-1.5 text-xs gap-1",
    md: "px-2.5 py-1.5 text-sm gap-1",
    lg: "px-3 py-1 text-sm gap-1.5",
  };

  return (
    <span
      className={`inline-flex items-center rounded-full font-medium ${sizes[size]} ${variants[variant]} ${className}`}
      {...props}
    >
      {children}
    </span>
  );
};
